import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type VerifyOtpForUpdatingUserPinMutationVariables = Types.Exact<{
   params: Types.VerifyOtpForUpdatingUserPinParams
}>

export type VerifyOtpForUpdatingUserPinMutation = {
   __typename?: 'Mutation'
   verifyOtpForUpdatingUserPin:
      | { __typename?: 'InvalidOTP'; message?: string | null; otp: string }
      | { __typename?: 'OTPIsExpired'; message?: string | null; otp: string }
      | { __typename?: 'OTPLengthMismatched'; message?: string | null }
      | {
           __typename?: 'OTPMaxRetriesExceeded'
           message?: string | null
           maxRetriesCount: number
        }
      | { __typename?: 'VerifyOtpForUpdatingUserPinResult'; success: boolean }
}

export const VerifyOtpForUpdatingUserPinDocument = gql`
   mutation VerifyOtpForUpdatingUserPin(
      $params: VerifyOtpForUpdatingUserPinParams!
   ) {
      verifyOtpForUpdatingUserPin(params: $params) {
         ... on VerifyOtpForUpdatingUserPinResult {
            success
         }
         ... on OTPIsExpired {
            message
            otp
         }
         ... on OTPMaxRetriesExceeded {
            message
            maxRetriesCount
         }
         ... on InvalidOTP {
            message
            otp
         }
         ... on OTPLengthMismatched {
            message
         }
      }
   }
`
export type VerifyOtpForUpdatingUserPinMutationFn = Apollo.MutationFunction<
   VerifyOtpForUpdatingUserPinMutation,
   VerifyOtpForUpdatingUserPinMutationVariables
>
export type VerifyOtpForUpdatingUserPinMutationResult = Apollo.MutationResult<
   VerifyOtpForUpdatingUserPinMutation
>
export type VerifyOtpForUpdatingUserPinMutationOptions = Apollo.BaseMutationOptions<
   VerifyOtpForUpdatingUserPinMutation,
   VerifyOtpForUpdatingUserPinMutationVariables
>
